import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import { api, app, use } from 'xadmin';
import React from 'react';
import { FormWrap } from 'xadmin-form'
import _ from 'lodash'

const Option = Select.Option;

const ParentNodeSelect = ({ onChange, value, model, modelId, department, label, multiple = true }) => {
  const [parents, setParents] = React.useState(null)
  const [oneSign, setOneSign] = React.useState(false)
  const [{ data, fetching }, setState] = React.useState({ data: [], fetching: false })
  const lastFetchId = React.useRef(0)
  const fetchNodeFn = React.useCallback(value => {
    lastFetchId.current += 1;
    const fetchId = lastFetchId.current;

    setState({ data: [], fetching: true });
    const schema = app.get('models')['Node']
    const filter = {
      limit: 9999,
      skip: 0,
      sort: { id: -1 }
    }
    const ids = parents && _.isArray(parents) && parents.map(item => {
      if (_.isString(item)) return item
      if (_.isPlainObject(item)) return item.id
    })

    const wheres = {
      filter: {
        modelId: {
          $in: modelId ? [...ids, modelId] : ids
        }
      }
    }
    if (value) wheres.filter.name = { '$regex': value }
    if (department) wheres.filter.department = department

    api({ ...schema }).query(filter, wheres).then(({ items }) => {
      if (fetchId !== lastFetchId.current) {
        setState({ data: [], fetching: false, })
        return;
      }
      setState({
        data: items,
        fetching: false,
      })
    })
      .catch((err) => {
        setState({ data: [], fetching: false, })
      })

  }, [parents, department])

  const fetchNode = debounce(fetchNodeFn, 800)


  React.useEffect(() => {
    setOneSign(true)
  }, [])

  React.useEffect(() => {

    if (model && model.relations && model.relations.parent) {
      setParents(model.relations.parent)
    }
    if (multiple) {
      oneSign && onChange([])
    } else {
      onChange(null)
    }
  }, [model && model.id])

  React.useEffect(() => {
    if (parents) {
      fetchNode()
    }
  }, [parents, department])


  const handleChanges = (value) => {
    if (value) {
      const ids = value.map(v => v.key)
      onChange(data.filter(d => ids.indexOf(d.id) >= 0))
    } else {
      onChange([])
    }
    setState({ data: [], fetching: false, data })
  }

  const handleChange = value => {
    if (value) {
      onChange(data.find(d => d.id == value.key))
    } else {
      onChange(null)
    }
    setState({
      fetching: false, data
    })
  }
  const placeholder = parents ? '请选择' + (parents.map(p => p.name).join(', ') ? (label || '') : '') : '请选择' + (label || '')
  return (
    <Select
      allowClear
      labelInValue
      disabled={!model}
      filterOption={false}
      onSearch={fetchNode}
      style={{ minWidth: 200 }}
      mode={multiple ? 'multiple' : 'default'}
      onChange={multiple ? handleChanges : handleChange}
      notFoundContent={fetching ? <Spin size="small" /> : '暂无数据'}
      placeholder={placeholder}
      value={value ?
        (multiple ? value && value.map(v => ({ key: v.id, label: v.name })) : { key: value.id, label: value.name }) :
        (multiple ? [] : undefined)}
    >
      {data.map(d => <Option key={d.id}>{d.name}</Option>)}
    </Select>
  )
}

function getUrlParameter(parameterName) {
  const url = window.location.href;
  const regex = new RegExp('[?&]' + parameterName + '=([^&#]+)');
  const match = url.match(regex);
  if (match) {
    return decodeURIComponent(match[1]);
  } else {
    return null;
  }
}


const ParentNodeSelectField = props => {
  const { input: { name, value, onChange }, label, meta, field } = props
  const { model } = use('form', state => ({ model: state.values ? state.values.model : null }))
  const nodeId = getUrlParameter('parentId')
  const modelId = getUrlParameter('modelId')


  React.useEffect(() => {
    nodeId && api('Node').get(nodeId).then(json => {
      onChange([json])
    })
  }, [nodeId])

  const _onChange = (value) => {
    onChange(value)
  }
  return <ParentNodeSelect onChange={_onChange} value={value} model={model} modelId={modelId} />
}

const ParentNodeFilter = props => {
  const { input: { name, value, onChange }, label, meta, field } = props
  const { model, department } = use('form', state => ({
    model: state.values ? state.values.model : null,
    department: state.values ? state.values.department : null
  }))
  return <ParentNodeSelect onChange={onChange} value={value} multiple={false} label={label} model={field.model || model} department={department} />
}

export {
  ParentNodeSelect,
  ParentNodeSelectField,
  ParentNodeFilter
}
